export default {
  filters: {
    managers: {
      placeholder: 'Menedżerowie sprzedaży',
    },
  },
  metrics: {
    collected_commission: 'Łączna prowizja',
  },
  fields: {
    manager: 'Menedżer',
    area: 'Lokalizacja',
    total_amount: 'Zarobki',
    companies_live: 'Aktywne',
    restaurant: 'Restauracja',
    live_from: 'Aktywny od',
    plan_amount: 'Kwota planu',
    prepayment_bonus_amount: 'Bonus za przedpłatę',
    lead_source_bonus_amount: 'Bonus za źródło leada',
    google_business_bonus_amount: 'Bonus za połączenie Google Business',
    promo_code_bonus_amount: 'Bonus za główny kod promocyjny',
    smart_pricing_bonus_amount: 'Bonus za inteligentne ceny',
    mobile_app_bonus_amount: 'Bonus za aplikację mobilną',
    sales_goal_bonus_amount: 'Bonus za cel sprzedażowy',
  },
  buttons: {
    export: 'Eksportuj',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
